import React from 'react';
import styled from 'styled-components';

import { getConfig } from '@zimpel/common/config';
import { FooterLogo } from '@zimpel/common/components/Logo';
import t from '@zimpel/common/helpers/i18n';
import { AppLink, ExternalLink } from '@zimpel/common/components/Links';
import { List } from '@zimpel/common/components/Lists';
import { GridCol, gridWidth } from '@zimpel/common/components/Grid';

const FooterContainer = styled.footer`
  width: 100%;
  height: var(--footer-height);
  background: var(--color-background-default);
  border-top: var(--border-box);
`;

const FooterCentered = styled.div`
  display: flex;
  align-items: center;
  width: ${gridWidth};
  height: var(--footer-height);
  margin: auto;
`;

const LogoContainer = styled.div`
  line-height: 1;

  > img {
    box-sizing: border-box;
    height: 25px;
    padding-left: var(--screen-padding-left);
  }
`;

const StaticPages = styled.div`
  display: flex;
  justify-content: end;
`;

const AppFooter: React.FC = () => {
  const { theme } = getConfig();

  return (
    <FooterContainer>
      <FooterCentered>
        <GridCol $width={6}>
          <LogoContainer>
            <FooterLogo alt={t('product_name')} />
          </LogoContainer>
        </GridCol>
        <GridCol $width={20}>
          <StaticPages>
            <List kind="inlined">
              <li>
                {t('view.layout.footer.links.newsaktuell_label')}
                {' '}
                <ExternalLink href={t('view.layout.footer.links.newsaktuell_url')}>
                  {t('view.layout.footer.links.newsaktuell')}
                </ExternalLink>
              </li>
              <li>
                <AppLink to="/imprint" hasUnderline>
                  {t('view.layout.footer.links.imprint')}
                </AppLink>
              </li>
              {theme === 'zimpel' && (
                <li>
                  <AppLink to="/privacy_notice" hasUnderline>
                    {t('view.layout.footer.links.privacy_notice')}
                  </AppLink>
                </li>
              )}
            </List>
          </StaticPages>
        </GridCol>
      </FooterCentered>
    </FooterContainer>
  );
};

export default AppFooter;
